import { apiClient } from './client';
import type { ApiResponse, PagedResult } from '@/types/api.types';
import type {
  ExchangeRateDto,
  ExchangeRateListDto,
  ExchangeRateFilterDto,
  CreateExchangeRateRequest,
  UpdateExchangeRateRequest,
} from '@/types/exchangeRate.types';

export const exchangeRateApi = {
  /** GET /api/v1/exchange-rates — paginated list with optional search/filter */
  getList: (filter?: ExchangeRateFilterDto) =>
    apiClient.get<ApiResponse<PagedResult<ExchangeRateListDto>>>('/exchange-rates', {
      params: filter,
    }),

  /** GET /api/v1/exchange-rates/{id} — full exchange rate record */
  getById: (id: string) =>
    apiClient.get<ApiResponse<ExchangeRateDto>>(`/exchange-rates/${id}`),

  /** POST /api/v1/exchange-rates — create a new exchange rate */
  create: (data: CreateExchangeRateRequest) =>
    apiClient.post<ApiResponse<{ id: string }>>('/exchange-rates', data),

  /** PUT /api/v1/exchange-rates/{id} — update exchange rate details */
  update: (id: string, data: UpdateExchangeRateRequest) =>
    apiClient.put<ApiResponse<object>>(`/exchange-rates/${id}`, data),

  /** DELETE /api/v1/exchange-rates/{id} — soft-delete the exchange rate */
  remove: (id: string) =>
    apiClient.delete<ApiResponse<object>>(`/exchange-rates/${id}`),
};
